import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ValidationService } from 'src/app/core/_services/common/validation.service';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { ChequePaymentComponent } from '../cheque-payment/cheque-payment.component';
import { PaymentComponent } from '../payment/payment.component';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';
import { TakeOnlinePaymentComponent } from '../take-online-payment/take-online-payment.component';
import { ComingSoonDialogComponent } from '../../coming-soon-dialog/coming-soon-dialog.component';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
// import { PaymentComponent } from '../payment/payment.component';

@Component({
  selector: 'app-choose-payment',
  templateUrl: './choose-payment.component.html',
  styleUrls: ['./choose-payment.component.scss']
})
export class ChoosePaymentComponent implements OnInit {
  paymentType = 1;
  isOnlinePayAvailable: boolean = false;
  constructor(private dialog: MatDialog, public dialogRef: MatDialogRef<ChoosePaymentComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private service: PagesService, private fb: FormBuilder, private loader: NgxUiLoaderService, private toastr: ToastrService, private router: Router, public validationService: ValidationService, private storage: LocalStorageProvider) {
    // this.chargeForm = this.createForm();
  }

  isAmountZero: boolean = false;
  ngOnInit(): void {
    this.isOnlinePayAvailable = this.storage.getItem('opAvail');
    if (this.data?.subNewData) {
      this.isAmountZero = this.data?.subNewData.amount == 0 ? true : false;
    }
  }

  pay() {
    if (this.data.subNewData) {
      this.data.subNewData['paymentType'] = this.paymentType;
      this.data.subNewData['isManage'] = true;
      this.data.subNewData['companyId'] = this.data.companyId;
      this.data.subNewData['duration'] = this.data.subNewData.duration;
      this.data.subNewData['permissionId'] = this.data.subNewData.permissionId;
      this.data.subNewData['packageName'] = this.data.subNewData.packageName;
      this.data.subNewData['packageId'] = this.data.subNewData.packageId;
    }
    if (this.paymentType == 3) {
      const dialogRef = this.dialog.open(ChequePaymentComponent, {
        maxHeight: '100vh',
        width: '700px',
        maxWidth: '100%',
        disableClose: true,
        data: {
          paymentType: 'check',
          clientData: this.data.clientData,
          subNewData: this.data?.subNewData ? this.data?.subNewData : null
        }
      });
      dialogRef.afterClosed().subscribe((confirm: any) => {
        if (confirm !== undefined && confirm !== null && confirm) {
          this.dialogRef.close(confirm);
        }
      });
    }
    else if (this.paymentType == 1) {
      const dialogRef = this.dialog.open(PaymentComponent, {
        maxHeight: '100vh',
        width: '700px',
        maxWidth: '100%',
        disableClose: true,
        data: {
          paymentType: 'cash',
          clientData: this.data.clientData,
          subNewData: this.data?.subNewData ? this.data?.subNewData : null
        }
      });
      dialogRef.afterClosed().subscribe((confirm: any) => {
        if (confirm !== undefined && confirm !== null && confirm) {
          this.dialogRef.close(confirm);
        }
      });
    } else if (this.paymentType == 2 && this.data?.subNewData) {
      if (this.isOnlinePayAvailable) {
        const dialogRef = this.dialog.open(TakeOnlinePaymentComponent, {
          maxHeight: '95vh',
          width: '700px',
          maxWidth: '100%',
          disableClose: true,
          data: {
            type: 'client',
            email: this.data?.email,
            subNewData: this.data?.subNewData ? this.data?.subNewData : null
          }
        });
        dialogRef.afterClosed().subscribe((confirm: any) => {
          if (confirm !== undefined && confirm !== null && confirm) {
            this.dialogRef.close(true);
          }
        });
      } else {
        const dialogRef = this.dialog.open(ComingSoonDialogComponent, {
          maxHeight: '100vh',
          width: '500px',
          disableClose: true,
          data: {}
        });
        dialogRef.afterClosed().subscribe((confirm: any) => {
        });
      }
    } else if (this.paymentType == 4) {
      this.loader.start();
      const payload = {
        companyId: this.data.companyId,
        permissionId: this.data.subNewData.permissionId,
        packageName: this.data.subNewData.packageName,
        packageId: this.data.subNewData.packageId,
        addOns: this.data.subNewData.addOns,
        numberOfTrucks: this.data.subNewData.numberOfTrucks,
        subscriptionId: this.data.subNewData.subscriptionId,
      }
      this.service.patch(`${API_ROUTES.CLIENT.requestPay}`, payload).subscribe(res => {
        this.loader.stop();
        if (res.status) {
          this.toastr.success(res.msg);
          this.dialogRef.close(true);
        } else {
          this.toastr.error(res.msg);
        }
      }, (err: any) => {
        this.loader.stop();
        this.toastr.error(err.msg);
      })
    }
  }

}
